// extracted by mini-css-extract-plugin
export default {"root":"UpgradePlanModal_root__d9WQh","button":"UpgradePlanModal_button__G5PB6"};